import { FunctionComponent } from "react";
import variables from "../../theme/variables";
import { IRosterSkill } from "../../types/Skill";
import S from "./styled";

type Props = {
  data: IRosterSkill;
};

const rarity = variables.COLORS.RARITY;

const Skill: FunctionComponent<Props> = ({ data }) => {
  const { dark, normal, light } = rarity[data.skillGrade];

  const style = {
    backgroundImage: `linear-gradient(to right, ${dark} 50%, ${normal})`,
    border: `2px solid ${normal}`,
  };

  return (
    <S.Skill>
      <S.Background style={style}></S.Background>
      <S.Level>
        Lv. <span>{data.level}</span>
      </S.Level>
      <S.Name>{data.name}</S.Name>
    </S.Skill>
  );
};

export default Skill;
